"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mining = void 0;
const react_1 = __importDefault(require("react"));
const loader_1 = require("@shared-modules/components/loader");
require("./styles.scss");
const translation_hooks_1 = require("@hooks/translation.hooks");
const Mining = (props) => {
    const { txCountPending } = props;
    const translator = (0, translation_hooks_1.useComponentTranslation)("notifications.mining");
    return (react_1.default.createElement("div", { className: "c-mining" },
        react_1.default.createElement("div", { className: "c-mining__loader" },
            react_1.default.createElement(loader_1.Loader, { scale: 0.5 })),
        react_1.default.createElement("div", { className: "c-mining__summary" }, translator("operationAmountInPendingLabel", { txCountPending }))));
};
exports.Mining = Mining;
